export default __webpack_public_path__ + "static/media/flexline_logo_no.797930d1.png";